import { Component } from '@angular/core';
//import { NotificationService } from '@progress/kendo-angular-notification';
import { NameValuePair } from 'src/app/models/NameValuePair';
import { MasterDataTypes } from 'src/app/models/SystemEnums';
import { EnumService } from 'src/app/services/enum/enum.service';
import { NotifyServiceService } from 'src/app/services/notify/notify-service.service';
import { ServerService } from 'src/app/services/server/server.service';

@Component({
    selector: 'app-master-data-editor',
    templateUrl: './master-data-editor.component.html',
    styleUrls: ['./master-data-editor.component.scss'],
    standalone: false
})
export class MasterDataEditorComponent {
  masterDataTypes: Array<NameValuePair> = [];

  id: number = 0;
  name: string;
  displayText: string;
  masterDataType: NameValuePair;

  constructor(
    private server: ServerService,
    private notify: NotifyServiceService,
    private enumService: EnumService
  ) {
    this.masterDataTypes = this.enumService.onGetMasterDataTypes();
  }

  onSave() {
    this.server
      .onSaveMasterDataItem(
        this.name,
        this.displayText,
        this.masterDataType.value,
        this.id
      )
      .subscribe({
        next: (res) => {
          if (res.success === true) {
            this.notify.showSuccess(res.message);
          } else {
            this.notify.showError(res.message);
          }
        },
        error: (err) => {
          this.notify.showError('Request failed');
        },
      });
  }
}
